import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { resetPassword } from '../services/authService';
import Navbar from "../components/landingpage/sections/Navbar";

const ResetPassword2 = (props) => {
    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: ''
    });
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [passwordErrors, setPasswordErrors] = useState([]);
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const navigate = useNavigate();

    const validatePassword = (password) => {
        const errors = [];
        if (password.length < 8) errors.push("At least 8 characters");
        if (!/(?=.*[a-z])/.test(password)) errors.push("One lowercase letter");
        if (!/(?=.*[A-Z])/.test(password)) errors.push("One uppercase letter");
        if (!/(?=.*\d)/.test(password)) errors.push("One number");
        if (!/(?=.*[@$!%*?&])/.test(password)) errors.push("One special character (@$!%*?&)");

        setPasswordErrors(errors);
        return errors.length === 0;
    };

    const isPasswordValid = formData.newPassword && passwordErrors.length === 0;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === 'newPassword') {
            validatePassword(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!formData.newPassword || !formData.confirmPassword) {
            setError("Please fill all fields");
            return;
        }

        if (!validatePassword(formData.newPassword)) {
            setError("Please fix password requirements");
            return;
        }

        if (formData.newPassword !== formData.confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        const email = localStorage.getItem('celebrityResetPasswordEmail');
        if (!email) {
            setError("Session expired. Please start over.");
            navigate('/forgot-password2');
            return;
        }

        setIsLoading(true);

        try {
            const response = await resetPassword(email, formData.newPassword);

            if (response.success) {
                setSuccess("Password reset successfully!");

                // Clear stored email
                localStorage.removeItem('celebrityResetPasswordEmail');

                // Redirect to celebrity login after delay
                setTimeout(() => {
                    navigate('/celebrity-login');
                }, 2000);
            }
        } catch (error) {
            setError(error.message || "Failed to reset password. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    return (
        <>
        <Navbar {...props} />
        <div className="login-content-info">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6">
                        <div className="account-content">
                            <div className="account-info">
                                <div className="login-title">
                                    <h3>Celebrity Create New Password</h3>
                                    <p>Enter your new password below.</p>
                                </div>

                                {error && <div className="alert alert-danger">{error}</div>}
                                {success && <div className="alert alert-success">{success}</div>}

                                <form onSubmit={handleSubmit}>
                                    <div className="form-group form-focus mt-4">
                                        <input
                                            type={isPasswordVisible ? "text" : "password"}
                                            className="form-control floating"
                                            name="newPassword"
                                            value={formData.newPassword}
                                            onChange={handleChange}
                                            onFocus={() => setIsPasswordFocused(true)}
                                            onBlur={() => setIsPasswordFocused(false)}
                                            placeholder=" "
                                            required
                                            minLength="8"
                                        />
                                        <span
                                            onClick={togglePasswordVisibility}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                                color: '#6c757d',
                                                fontSize: '16px',
                                                zIndex: 10
                                            }}
                                        >
                                            {isPasswordVisible ? '🙈' : '👁️'}
                                        </span>
                                        <label className="focus-label">New Password</label>

                                        {(isPasswordFocused || formData.newPassword) && (
                                            <div className="password-requirements mt-2">
                                                <small className="d-block text-muted">
                                                    {isPasswordValid ? '✓ Password meets all requirements' : 'Password must include:'}
                                                </small>
                                                {!isPasswordValid && (
                                                    <ul className="list-unstyled mb-0" style={{ fontSize: '12px' }}>
                                                        <li className={formData.newPassword.length >= 8 ? 'text-success' : 'text-danger'}>
                                                            {formData.newPassword.length >= 8 ? '✓ ' : '• '}
                                                            At least 8 characters
                                                        </li>
                                                        <li className={/(?=.*[a-z])/.test(formData.newPassword) ? 'text-success' : 'text-danger'}>
                                                            {/(?=.*[a-z])/.test(formData.newPassword) ? '✓ ' : '• '}
                                                            One lowercase letter
                                                        </li>
                                                        <li className={/(?=.*[A-Z])/.test(formData.newPassword) ? 'text-success' : 'text-danger'}>
                                                            {/(?=.*[A-Z])/.test(formData.newPassword) ? '✓ ' : '• '}
                                                            One uppercase letter
                                                        </li>
                                                        <li className={/(?=.*\d)/.test(formData.newPassword) ? 'text-success' : 'text-danger'}>
                                                            {/(?=.*\d)/.test(formData.newPassword) ? '✓ ' : '• '}
                                                            One number
                                                        </li>
                                                        <li className={/(?=.*[@$!%*?&])/.test(formData.newPassword) ? 'text-success' : 'text-danger'}>
                                                            {/(?=.*[@$!%*?&])/.test(formData.newPassword) ? '✓ ' : '• '}
                                                            One special character (@$!%*?&)
                                                        </li>
                                                    </ul>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-group form-focus">
                                        <input
                                            type={isPasswordVisible ? "text" : "password"}
                                            className="form-control floating"
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                            placeholder=" "
                                            required
                                            minLength="8"
                                        />
                                        <span
                                            onClick={togglePasswordVisibility}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                                color: '#6c757d',
                                                fontSize: '16px',
                                                zIndex: 10
                                            }}
                                        >
                                            {isPasswordVisible ? '🙈' : '👁️'}
                                        </span>
                                        <label className="focus-label">Confirm Password</label>
                                        {formData.confirmPassword && formData.newPassword !== formData.confirmPassword && (
                                            <small className="text-danger">Passwords do not match</small>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <button
                                            type="submit"
                                            className="btn btn-primary-gradient w-100"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? "Resetting..." : "Reset Password"}
                                        </button>
                                    </div>

                                    <div className="account-signup">
                                        <p>
                                            Remember Password? <Link to="/celebrity-login">Sign In</Link>
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ResetPassword2;